<template>
    <div>
        <template v-if="viewPage == true">
            <div class="modal fade" id="batchSummary" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body batchSummary-payment-popup text-left p-4">
                            <div class="popup-head line-head">
                                <h2 class="pb-2"> Batch Summary </h2>
                            </div>
                            <div class="row normal-ib-space mt-3">
                                <div class="col-md-12 mb-3">
                                    <h3>Batch is uploaded and under processing click proceed to continue</h3>
                                    <!-- <table width="100%" v-if="batchSummary != null">
                                        <tr>
                                            <td> New records inserted </td>
                                            <td> {{batchSummary.inserted}} </td>
                                        </tr>
                                        <tr>
                                            <td> Existing records updated </td>
                                            <td> {{batchSummary.updated}} </td>
                                        </tr>
                                        <tr>
                                            <td> Discrepant records </td>
                                            <td> {{batchSummary.discrepants}} </td>
                                        </tr>
                                    </table> -->
                                </div>
                                <div class="col align-right"> 
                                    <button class="btn btn-primary" v-on:click="proceedToEmployees"> Proceed </button>
                                    <button class="btn btn-primary" v-if="unregisterWallet.length > 0" v-on:click="csvExport"> Download Discrepants</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Login Modal End-->
            <div class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addDepartment" tabindex="-1" aria-labelledby="addDepartment" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Department  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="departmentForm.name" class="form-control" name="name" id="departmentAddValue" :class="{ 'is-invalid': departmentForm.errors.has('name') }"/>
                                <has-error :form="departmentForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveDepartment()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addDesignation" tabindex="-1" aria-labelledby="addDesignation" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Designation  </h2>
                            </div>
                            <div class="form-group">
                                <label> Designation </label>
                                <input type="text" v-model="designationForm.name" class="form-control" name="name" id="designationAddValue" :class="{ 'is-invalid': designationForm.errors.has('name') }"/>
                                <has-error :form="designationForm" field="name"></has-error>
                            </div>
                            <div class="form-group">
                                <label> Departments </label>
                                <select v-model="designationForm.department_id" data-live-search="true" name="department_id" autocomplete="off" 
                                class="form-control pms" :class="{ 'is-invalid': designationForm.errors.has('department_id') }">
                                    <option value="">Select Department</option>
                                    <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">{{ department.name }}</option>
                                </select>
                                <has-error :form="designationForm" field="department_id"></has-error>
                            </div>
                            <div class="form-group">
                                <label>Designation Description</label>
                                <input v-model="designationForm.designation_description" type="text" name="designation_description" class="form-control" :class="{ 'is-invalid': designationForm.errors.has('designation_description') }">
                                <has-error :form="designationForm" field="designation_description"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveDesignation()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCity" tabindex="-1" aria-labelledby="addCity" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add City  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="cityForm.name" class="form-control" name="name" id="cityAddValue" :class="{ 'is-invalid': cityForm.errors.has('name') }"/>
                                <has-error :form="cityForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCity()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addBranch" tabindex="-1" aria-labelledby="addBranch" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Branch  </h2>
                            </div>
                            <div class="form-group">

                                <input type="text" v-model="branchForm.name" class="form-control" name="name" id="branchAddValue" :class="{ 'is-invalid': branchForm.errors.has('name') }"/>
                                <has-error :form="branchForm" field="name"></has-error>
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveBranch()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Employee Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <button v-if="page_title == 'finjaCard'" class="btn btn-primary float-right mr-1" onclick="location.reload();"> Cancel </button>
                    <router-link v-if="page_title == 'EmployeeBulk'" class="btn btn-primary float-right mr-1" to="/employees"> Cancel </router-link>
                    
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p v-show="$global.user_company_payment_engine != 'FAYSAL'">Download a bank code template <a :href="`${$global.base_url}csv/BankCode`" target="_blank">here.</a> </p>
                            <p> You can also download a sample template <a :href="`${$global.base_url}csv/EmployeeBulk`" target="_blank">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must meet the
                            following requirements in
                            order to upload employees
                            in Bulk: <br/>
							1. Mandatory fields : Mobile Number, Basic Salary, Gross Salary, Date of Joining, Employment Status, Account Type,Bank Code , Account Number, cnic<br/>
							2. Only add registered account numbers.<br/>
							3. Mobile numbers must be in the following format: 923XXXXXXXXX.<br/>
							4. Set the formatting of mobile number column to “Number” with zero decimal places.<br/>
							5. No repetition of column names.<br/>
							6. No empty cells in a valid row.<br/>
							7. No special characters in the sheet.</p>">

                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="”Mandatory Information” contain fields that are required for Finja Business to process your sheet."></i> </label>
                                    <div class="mandatory-tags">
                                        <div class="mandatory-fields-inner">
                                            <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobile_number" class="fas fa-check"></i> Mobile Number </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Basic Salary"> <i v-show="mand_basic_salary" class="fas fa-check"></i> Basic Salary </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Gross Salary"> <i v-show="mand_gross_salary" class="fas fa-check"></i> Gross Salary </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Date of Joining"> <i v-show="mand_doj" class="fas fa-check"></i> Date of Joining </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Employment Status"> <i v-show="mand_employment_status" class="fas fa-check"></i> Employment Status </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_cnic" class="fas fa-check"></i> CNIC </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Bank Code"> <i v-show="mand_bank_code" class="fas fa-check"></i> Bank Code </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Account Number"> <i v-show="mand_account_number" class="fas fa-check"></i> Account Number </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Account Type"> <i v-show="mand_account_type" class="fas fa-check"></i> Account Type </span> </div>
                                            <div class="mandatory-field-col"> <span class="map-value" title="Default"> <i v-show="mand_default" class="fas fa-check"></i> Default </span> </div>
                                        </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="viewPage == null">
            <div class="inside-loader">
                <div class="inside-loader-inner">
                    <img src="/images/payroll.png" alt="" />
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </div>
        </template>
        <template v-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null; 
    export default {
        data() {
            return {
                page_title : this.$route.path,
                unregisterWallet:{},
                cityForm: new Form({
                    name : '',
                }),
                departmentForm: new Form({
                    name : '',
                }),
                designationForm: new Form({
                    name : '',
                    department_id : '',
                    designation_description : '',
                }),
                branchForm: new Form({
                    name : '',
                }),
                viewPage : true,
                previewMapField : false,
                mand_name : false,
                mand_father_name : false,
                mand_email : false,
                mand_employment_status : false,
                mand_mobile_number : false,
                mand_cnic : false,
                mand_account_type : false,
                mand_bank_code : false,
                mand_account_number : false,
                mand_gross_salary : false,
                mand_doj : false,
                mand_basic_salary : false,
                mand_department : false,
                mand_branch : false,
                mand_city : false,
                mand_designation : false,
                mand_address : false,
                mand_tax : false,
                mand_filer : false,
                mand_ntn : false,
                mand_default: false,
                gender : false,
                pf_status : false,
                pf_cc : false,
                pf_ec : false,
                // default : false,
                advance_incomtax_pay : false,
                employee_code : false,
                fileAdded : false,
                filecolumn : [],
                fileRowData : [],
                departmentCount : 0,
                departmentMapped : 0,
                branchCount : 0,
                branchMapped : 0,
                cityCount : 0,
                cityMapped : 0,
                designationCount : 0,
                designationMapped : 0,
                departmentLi : [],
                branchLi : [],
                cityLi :[],
                designationLi : [],
                finalDepartmentArray : [],
                finaldesignationArray : [],
                finalcityArray : [],
                finalBranchArray : [],
                dropZoneObject : null,
                proceedButtonflag : false,
                batchSummary : null,
                departments: null,
            }
        },
        methods: {
            csvExport() {
                let that = this;
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    ['Name',
                    'Mobile Number',
                    'Account Type',
                    'Bank Code',
                    'Account Number',
                    'Employee Code',
                    'CNIC',
                    'Gender',
                    'Date of birth',
                    'Date of Joining',
                    'Email',
                    'Department',
                    'Branch',
                    'City',
                    'Designation',
                    'Gross Salary',
                    'Basic Salary',
                    'Provident Fund Status',
                    'Provident Fund Company Contribution',
                    'Provident Fund Employee Contribution',
                    'Advance Income Tax Pay',
                    'Employment Status',
                    'Current Address'],
                    ...that.unregisterWallet.map(item => item)
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");
                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "Descrepant Records.csv");
                link.click();
            },

            proceedToEmployees(){
                $('#batchSummary').modal('hide');
                this.$router.push('employees');
            },
            processDropzoneQueue(){

            },
            getBulkUploadData(){
                var that = this;
                this.$Progress.start();
                axios.get('/api/getEmployeeBulkUploadData')
                    .then(res => {
                        if(res.status == 200){
                            res.data.departments.forEach(dept => {
                            that.departmentLi.push({value:dept.id,label:dept.name});
                            });
                            res.data.branches.forEach(branch => {
                            that.branchLi.push({value:branch.id,label:branch.name});
                            });
                            res.data.cities.forEach(city => {
                            that.cityLi.push({value:city.id,label:city.name});
                            });
                            res.data.designations.forEach(designation => {
                            that.designationLi.push({value:designation.id,label:designation.name});
                            });
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                    });
            },
            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    timeout:0,
                    url: that.$global.base_url+'api/employeeBulkUpload',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            var ext = file.name.split('.')[1];
                            var invalid = 0;
                            if(ext != 'csv'){
                                that.showToastBox('error','Invalid file added');
                                this.removeFile(file);
                                return false;
                            }
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            that.$Progress.start();
                            $('div.progress').addClass('step-three').removeClass('step-two');
                            if(
                                (that.departmentCount > 0 && that.departmentCount != that.departmentMapped) ||
                                (that.designationCount > 0 && that.designationCount != that.designationMapped) ||
                                (that.cityCount > 0 && that.cityCount != that.cityMapped) ||
                                (that.branchCount > 0 && that.branchCount != that.branchMapped)
                            ){

                                if($("#needAttention").hasClass('show')){
                                    that.showAlertBox('error','Please either add them or associate them with exisiting ones.');
                                }else{
                                    $("#needAttention").modal("show");
                                }
                                that.$Progress.finish();
                            }else{
                                that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                            }
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var departmentNames = [];
                            var departmentids = [];

                            var designationNames = [];
                            var designationids = [];

                            var cityNames = [];
                            var cityids = [];

                            var branchNames = [];
                            var branchids = [];

                            that.finalDepartmentArray.forEach(dept => {
                                departmentNames.push(dept.name);
                                departmentids.push(dept.id);
                            });

                             that.finaldesignationArray.forEach(cat => {
                                designationNames.push(cat.name);
                                designationids.push(cat.id);
                            });

                             that.finalcityArray.forEach(city => {
                                cityNames.push(city.name);
                                cityids.push(city.id);
                            });

                             that.finalBranchArray.forEach(branch => {
                                branchNames.push(branch.name);
                                branchids.push(branch.id);
                            });
                            // Will send the filesize along with the file as POST data.
                            formData.append("departmentNames", JSON.stringify(departmentNames));
                            formData.append("departmentids", JSON.stringify(departmentids));
                            formData.append("designationNames", JSON.stringify(designationNames));
                            formData.append("designationids", JSON.stringify(designationids));
                            formData.append("cityNames", JSON.stringify(cityNames));
                            formData.append("cityids", JSON.stringify(cityids));
                            formData.append("branchNames", JSON.stringify(branchNames));
                            formData.append("branchids", JSON.stringify(branchids));
                            formData.append("filesize", file.size);
                            formData.append("route", that.page_title);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            var msg = null;
                            if(obj.code == "200") {
                                if($("#needAttention").hasClass('show')){
                                    $("#needAttention").modal("hide");
                                }
                                that.$Progress.finish();
                                that.batchSummary = obj.data;
                                that.unregisterWallet = obj.data.unregisterWalletBulkUpload;
                                $('#batchSummary').modal('show');
                                if(that.page_title == 'finjaCard'){
                                    if(that.batchSummary != null){
                                        if(that.batchSummary.inserted > 0 || that.batchSummary.updated > 0){
                                            that.showAlertBox('success','','Your employee data has been received for Finja Card whitelisting. You will be contacted by our representative shortly. Thank you!');
                                        }
                                    }
                                }else{
                                    that.showToastBox('success','Employees uploaded successfully');
                                }

                                //that.$router.push('/employees');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });

                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            if(401 == xhr.status){
                                swal.fire({
                                    title: "Session Expired",
                                    text: "Your session has expired. Would you like to be redirected to the login page?",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Yes",
                                    closeOnConfirm: false
                                }).then((result) => {
                                    if (result.value) {
                                        window.location = '/login';
                                    }
                                });
                            }else{
                                var msg = '<strong>Error:'+xhr.status+'</strong> '+xhr.statusText;
                                that.showAlertBox('error','Error in file', msg);
                            }
                            file.status = Dropzone.QUEUED;
                        });
                    }


                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var deptRowid = 0;
                var designationRowid = 0;
                var cityRowid = 0;
                var branchRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            if(data[row] != ""){
                                for(var item in data[row]){
                                    var value = data[row][item];
                                    _row.push(value);
                                }
                                that.fileRowData.push(_row);
                            }
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobile_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account type'){
                            that.mand_account_type = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'bank code'){
                            that.mand_bank_code = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'account number'){
                            that.mand_account_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'employee code'){
                            that.employee_code = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'cnic'){
                            that.mand_cnic = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'gender'){
                            that.gender = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'date of birth'){
                            that.mand_dob = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'date of joining'){
                            that.mand_doj = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'email'){
                            that.mand_email = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'department'){
                            that.mand_department = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'branch'){
                            that.mand_branch = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'city'){
                            that.mand_city = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'designation'){
                            that.mand_designation = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'gross salary'){
                            that.mand_gross_salary = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'basic salary'){
                            that.mand_basic_salary = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'provident fund status'){
                            that.pf_status = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'provident fund company contribution'){
                            that.pf_cc = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'provident fund employee contribution'){
                            that.pf_ec = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'advance income tax pay'){
                            that.advance_incomtax_pay = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'employment status'){
                            that.mand_employment_status = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'current address'){
                            that.mand_address = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'default'){
                            that.mand_default = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Student Detail">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="Mobile Number" '+selected+'>Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account type') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account type') ? true : fieldMap;
                        comboBox += '<option value="Account Type" '+selected+'>Account Type</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'bank code') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'bank code') ? true : fieldMap;
                        comboBox += '<option value="Bank Code" '+selected+'>Bank Code</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'account number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'account number') ? true : fieldMap;
                        comboBox += '<option value="Account Number" '+selected+'>Account Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'employee code') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'employee code') ? true : fieldMap;
                        comboBox += '<option value="Employee code" '+selected+'>Employee code</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic') ? true : fieldMap;
                        comboBox += '<option value="CNIC" '+selected+'>CNIC</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'gender') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'gender') ? true : fieldMap;
                        comboBox += '<option value="Gender" '+selected+'>Gender</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'date of birth') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'date of birth') ? true : fieldMap;
                        comboBox += '<option value="Date of Birth" '+selected+'>Date of Birth</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'date of joining') ? true : fieldMap;
                        comboBox += '<option value="Date of Joining" '+selected+'>Date of Joining</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email') ? true : fieldMap;
                        comboBox += '<option value="Email" '+selected+'>Email</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'department') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'department') ? true : fieldMap;
                        comboBox += '<option value="Department" '+selected+'>Department</option>';
                        if(selected == 'selected'){
                            deptRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'branch') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'branch') ? true : fieldMap;
                        comboBox += '<option value="Branch" '+selected+'>Branch</option>';
                        if(selected == 'selected'){
                            branchRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'city') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'city') ? true : fieldMap;
                        comboBox += '<option value="City" '+selected+'>City</option>';
                        if(selected == 'selected'){
                            cityRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'designation') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'designation') ? true : fieldMap;
                        comboBox += '<option value="Designation" '+selected+'>Designation</option>';
                        if(selected == 'selected'){
                            designationRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'gross salary') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'gross salary') ? true : fieldMap;
                        comboBox += '<option value="Gross salary" '+selected+'>Gross Salary</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'basic salary') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'basic salary') ? true : fieldMap;
                        comboBox += '<option value="Basic salary" '+selected+'>Basic Salary</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'provident fund status') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'provident fund status') ? true : fieldMap;
                        comboBox += '<option value="Provident Fund Status" '+selected+'>Provident Fund Status</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'provident fund company contribution') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'provident fund company contribution') ? true : fieldMap;
                        comboBox += '<option value="Provident Fund Company Contribution" '+selected+'>Provident Fund Company Contribution</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'provident fund employee contribution') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'provident fund employee contribution') ? true : fieldMap;
                        comboBox += '<option value="Provident Fund Employee Contribution" '+selected+'>Provident Fund Employee Contribution</option>';

                        selected = (rowName.trim().toLocaleLowerCase() == 'advance income tax pay') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'advance income tax pay') ? true : fieldMap;
                        comboBox += '<option value="Advance Income Tax Pay" '+selected+'>Advance Income Tax Pay</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'employment status') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'employment status') ? true : fieldMap;
                        comboBox += '<option value="Employment Status" '+selected+'>Employment Status</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'current address') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'current address') ? true : fieldMap;
                        comboBox += '<option value="Current Address" '+selected+'>Current Address</option>';

                        selected = (rowName.trim().toLocaleLowerCase() == 'default') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'default') ? true : fieldMap;
                        comboBox += '<option value="Default" '+selected+'>Default</option>';

                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    if(deptRowid != 0){
                        that.showFieldInIdentifiers('department',that.fileRowData,deptRowid);
                    }
                    if(designationRowid != 0){
                        that.showFieldInIdentifiers('designation',that.fileRowData,designationRowid);
                    }
                    if(cityRowid != 0){
                        that.showFieldInIdentifiers('city',that.fileRowData,cityRowid);
                    }
                    if(branchRowid != 0){
                        that.showFieldInIdentifiers('branch',that.fileRowData,branchRowid);
                    }
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                if(this.mand_mobile_number == true && this.mand_basic_salary == true && this.mand_gross_salary == true && this.mand_doj == true && this.mand_employment_status == true && this.mand_account_type == true  && this.mand_account_number == true  && this.mand_cnic == true  && this.mand_bank_code == true && this.mand_default == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                    this.showAlertBox('error','Please fill the mandatory fields .');
                }
            },
            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_mobile_number = this.mand_basic_salary = this.mand_gross_salary = this.mand_doj = this.mand_employment_status = this.mand_account_type = this.mand_account_number = this.mand_cnic = this.mand_bank_code = false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'mobile number') this.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'cnic') this.mand_cnic = true;
                    if(selVal.trim().toLowerCase() == 'bank code') this.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') this.mand_account_number = true;

                    if(selVal.trim().toLowerCase() == 'Basic Salary') this.mand_basic_salary = true;
                    if(selVal.trim().toLowerCase() == 'Gross Salaryr') this.mand_gross_salary = true;
                    if(selVal.trim().toLowerCase() == 'Date Of Joining') this.mand_doj = true;
                    if(selVal.trim().toLowerCase() == 'Employment Status') this.mand_employment_status = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    //hide the department, branch and city field sets if deselect
                    if(previous.toLowerCase() == 'department'){
                        $('div.departmentTable').remove();
                        $('table.departmentTable').remove();
                    }
                    if(previous.toLowerCase() == 'designation'){
                        $('div.designationTable').remove();
                        $('table.designationTable').remove();
                    }
                    if(previous.toLowerCase() == 'city'){
                        $('div.cityTable').remove();
                        $('table.cityTable').remove();
                    }
                    if(previous.toLowerCase() == 'branch'){
                        $('div.branchTable').remove();
                        $('table.branchTable').remove();
                    }
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'cnic') that.mand_cnic = true;
                    if(selVal.trim().toLowerCase() == 'bank code') that.mand_bank_code = true;
                    if(selVal.trim().toLowerCase() == 'account number') that.mand_account_number = true;
                    if(selVal.trim().toLowerCase() == 'Basic Salary') that.mand_basic_salary = true;
                    if(selVal.trim().toLowerCase() == 'Gross Salaryr') that.mand_gross_salary = true;
                    if(selVal.trim().toLowerCase() == 'Date Of Joining') that.mand_doj = true;
                    if(selVal.trim().toLowerCase() == 'Employment Status') that.mand_employment_status = true;

                    that.generateButtonProccess();
                });
            },
            showFieldInIdentifiers(datafor,fileRowData,itemIndex){
                var dataTableFor = '';
                var mappingfor = '';
                if(datafor == 'department'){
                    mappingfor = '<h3>We\'ve found some new departments.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'departmentTable';
                }
                if(datafor == 'city'){
                    mappingfor = '<h3>We\'ve found some new cities.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'cityTable';
                }
                if(datafor == 'designation'){
                    mappingfor = '<h3>We\'ve found some new designations.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'designationTable';
                }
                if(datafor == 'branch'){
                    mappingfor = '<h3>We\'ve found some new branches.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'branchTable';
                }
                var html = mappingfor;
                if(datafor == 'department'){
                    var departmentArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var department = data[itemIndex];
                        if(department != '' && departmentArray.indexOf(department) == -1){
                            departmentArray.push(department);
                        }
                    }
                    this.departmentCount = departmentArray.length;
                    for(var k = 0; k < this.departmentCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultDepartment = 'Select department';
                        for(var t=0; t < this.departmentLi.length; t++){
                            if(this.departmentLi[t].label.toLowerCase() == departmentArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultDepartment = this.departmentLi[t].label;
                                this.finalDepartmentArray.push({id:this.departmentLi[t].value,name:departmentArray[k]});
                                this.departmentMapped = this.finalDepartmentArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory department"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+this.departmentLi[t].value+'\',\''+departmentArray[k]+'\',this);">'+this.departmentLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+departmentArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown dept">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Department<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="department_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-department"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addDepartment"><i class="fas fa-plus"></i> Add Department</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'designation'){
                    var designationArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var designation = data[itemIndex];
                        if(designation != '' && designationArray.indexOf(designation) == -1){
                            designationArray.push(designation);
                        }
                    }
                    this.designationCount = designationArray.length;
                    for(var k = 0; k < this.designationCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultDesignation = 'Select Designation';
                        for(var t=0; t < this.designationLi.length; t++){
                            if(this.designationLi[t].label.toLowerCase() == designationArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultDesignation = this.designationLi[t].label;
                                this.finaldesignationArray.push({id:this.designationLi[t].value,name:designationArray[k]});
                                this.designationMapped = this.finaldesignationArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory designation"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDesignationSelection(\''+this.designationLi[t].value+'\',\''+designationArray[k]+'\',this);">'+this.designationLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+designationArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Designation<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="designation_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-category"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addDesignation"><i class="fas fa-plus"></i> Add Designation</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'city'){
                    var cityArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var city = data[itemIndex];
                        if(city != '' && cityArray.indexOf(city) == -1){
                            cityArray.push(city);
                        }
                    }
                    this.cityCount = cityArray.length;
                    for(var k = 0; k < this.cityCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCity = 'Select City';
                        for(var t=0; t < this.cityLi.length; t++){
                            if(this.cityLi[t].label.toLowerCase() == cityArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCity = this.cityLi[t].label;
                                this.finalcityArray.push({id:this.cityLi[t].value,name:cityArray[k]});
                                this.cityMapped = this.finalcityArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory city"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+this.cityLi[t].value+'\',\''+cityArray[k]+'\',this);">'+this.cityLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+cityArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select City<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="city_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-city"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCity"><i class="fas fa-plus"></i> Add City</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                if(datafor == 'branch'){
                    var branchArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var branch = data[itemIndex];
                        if(branch != '' && branchArray.indexOf(branch) == -1){
                            branchArray.push(branch);
                        }
                    }
                    this.branchCount = branchArray.length;
                    for(var k = 0; k < this.branchCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultBranch = 'Select Branch';
                        for(var t=0; t < this.branchLi.length; t++){
                            if(this.branchLi[t].label.toLowerCase() == branchArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultBranch = this.branchLi[t].label;
                                this.finalBranchArray.push({id:this.branchLi[t].value,name:branchArray[k]});
                                this.branchMapped = this.finalBranchArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="vendorBulkUploadCategory branch"><a class="dropdown-link" href="javascript:void(0)" onclick="mapBranchSelection(\''+this.branchLi[t].value+'\',\''+branchArray[k]+'\',this);">'+this.branchLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+branchArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Branch<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="branch_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-branch"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addBranch"><i class="fas fa-plus"></i> Add Branch</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                $('div.need-attention-content').append(html);
                this.customCombo();
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        // $('div#duplicatemessage').html() +
                        var error_message = duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
            saveDepartment(){
                var departmentValue = $('#departmentAddValue').val();
                if (departmentValue === "") {
                    that.showAlertBox('error','Please enter department name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.departmentForm.post('/api/addDepartment')
                    .then(response => {
                        if(response.status == 200){
                            that.finalDepartmentArray.push({id:response.data.data.id,name:departmentValue});
                            that.departmentMapped = that.finalDepartmentArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDepartmentSelection(\''+response.data.data.id+'\',\''+departmentValue+'\',this);">'+departmentValue+'</a></li>';
                            $('ul.department_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addDepartment").modal("hide");
                            that.showToastBox('success','Department has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    }).catch(err => {
                    this.$Progress.fail();
                });
                }
            },
            saveDesignation(){
                var designationValue = $('#designationAddValue').val();
                if (designationValue === "") {
                    gThat.showAlertBox('error','Please enter designation name');
                }else{
                    gThat.$Progress.start();
                    this.designationForm.post('/api/addDesignation')
                    .then(response => {
                        if(response.status == 200){
                            gThat.finaldesignationArray.push({id:response.data.data.id,name:designationValue});
                            gThat.designationMapped = gThat.finaldesignationArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapDesignationSelection(\''+response.data.data.id+'\',\''+designationValue+'\',this);">'+designationValue+'</a></li>';
                            $('ul.designation_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addDesignation").modal("hide");
                            gThat.showToastBox('success','Designation has been added');
                            gThat.$Progress.finish();
                        }else{
                            gThat.showAlertBox('error','Something went wrong !');
                            gThat.$Progress.fail();
                        }
                    }).catch((err)=>{
                        console.log(err);
                        gThat.showAlertBox('error','Something went wrong !!');
                        gThat.$Progress.fail();
                    });
                }
            }
            ,
            saveCity(){
                var cityValue = $('#cityAddValue').val();
                if (cityValue === "") {
                    that.showAlertBox('error','Please enter city name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.cityForm.post('/api/addCity')
                    .then(response => {
                        if(response.status == 200){
                            that.finalcityArray.push({id:response.data.data.id,name:cityValue});
                            that.cityMapped = that.finalcityArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCitySelection(\''+response.data.data.id+'\',\''+cityValue+'\',this);">'+cityValue+'</a></li>';
                            $('ul.city_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addCity").modal("hide");
                            that.showToastBox('success','City has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            },
            saveBranch(){
                var branchValue = $('#branchAddValue').val();
                if (branchValue === "") {
                    that.showAlertBox('error','Please enter branch name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    this.branchForm.post('/api/addBranch')
                    .then(response => {
                        if(response.status == 200){
                            that.finalBranchArray.push({id:response.data.data.id,name:branchValue});
                            that.branchMapped = that.finalBranchArray.length;
                            var html = '<li class="vendorBulkUploadCategory"><a class="dropdown-link" href="javascript:void(0)" onclick="mapBranchSelection(\''+response.data.data.id+'\',\''+branchValue+'\',this);">'+branchValue+'</a></li>';
                            $('ul.branch_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addBranch").modal("hide");
                            that.showToastBox('success','Branch has been added');
                            this.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            this.$Progress.fail();
                        }
                    });
                }
            },
            getDepartments() // PMS
            {
                this.$Progress.start();
                axios.get('/api/getDepartments')
                .then(res => {
                    if(res.data.code == 200)
                    {
                        this.departments = res.data.data;
                        this.$Progress.finish();
                    }
                    else
                    {
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in fetching data for departments');
                });
            },
        },
        updated(){
            $("body").on("click" , ".dropdown-menu .vendorBulkUploadCategory a", function(e){
                e.preventDefault();
                $(this).parents('.dropdown').find('.drop-value-changer').html($(this).text());
            });
            var idCount = 1;
            $('.list').each(function() {
                $(this).attr('id', 'dropdown-menu' + idCount);
                idCount++;
            });
            $('.add-category .btn-primary').click(function(){
                var selectID = $(this).parent().siblings('.list').attr('id');
                var popupValue = $('#popu-value').val(selectID);
            })
        },
        created() {
        },
        mounted(){
            if(this.page_title == "/finjaCard"){
                this.page_title = "finjaCard";
            }else{
                this.page_title = "EmployeeBulk";
            }
        console.log(this.page_title);
            var that = this;
            gThat = this;
            this.initDropZone();
            $("#drop").dropzone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            this.getBulkUploadData();
            this.getDepartments();
            $(window.document).on('show.bs.modal', '.modal', function (event) {
                var zIndex = 1040 + (10 * $('.modal:visible').length);
                $(this).css('z-index', zIndex);
                setTimeout(function() {
                    $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                }, 0);
            });



            window.mapDepartmentSelection = function(id,value,obj){
                // $(obj).parent().find("li").removeClass("row-enabled");
                // $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalDepartmentArray){
                    if(that.finalDepartmentArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalDepartmentArray.splice(index,1);
                        that.finalDepartmentArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalDepartmentArray.push({id:id,name:value});
                }
                that.departmentMapped = that.finalDepartmentArray.length;
                that.generateButtonProccess();
            }
            window.mapDesignationSelection = function(id,value,obj){
                $(obj).parent().find("li").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finaldesignationArray){
                    if(that.finaldesignationArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finaldesignationArray.splice(index,1);
                        that.finaldesignationArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finaldesignationArray.push({id:id,name:value});
                }
                that.designationMapped = that.finaldesignationArray.length;
                that.generateButtonProccess();
            }
            window.mapCitySelection = function(id,value,obj){
                $(obj).parent().find("li").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalcityArray){
                    if(that.finalcityArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalcityArray.splice(index,1);
                        that.finalcityArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalcityArray.push({id:id,name:value});
                }
                that.cityMapped = that.finalcityArray.length;
                that.generateButtonProccess();
            }
            window.mapBranchSelection = function(id,value,obj){
                $(obj).parent().find("li.branch").removeClass("row-enabled");
                $(obj).addClass('row-enabled');
                var valueExist = false;
                for(var index in that.finalBranchArray){
                    if(that.finalBranchArray[index].name.toLowerCase() == value.toLowerCase()){
                        that.finalBranchArray.splice(index,1);
                        that.finalBranchArray.push({id:id,name:value});
                        valueExist = true;
                        break;
                    }
                }
                if(valueExist === false){
                    that.finalBranchArray.push({id:id,name:value});
                }
                that.branchMapped = that.finalBranchArray.length;
                that.generateButtonProccess();
            }
        }
    }
</script>
